import React from 'react';
import { withTranslation } from 'react-i18next';
import axios from 'axios';

// @material-ui
import {
    Facebook,
    Twitter,
    Instagram,
    YouTube,
    Pinterest,
    LinkedIn,
    Close,
    RemoveCircleOutline,
} from '@mui/icons-material';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    InputAdornment,
    Input,
    TextareaAutosize,
    TextField,
} from '@mui/material';

// core components
import CustomInput from 'components/CustomInput/CustomInput.js';
import ConfirmDialog from 'components/ConfirmDialog/ConfirmDialog';
import Autocomplete from '@mui/material/Autocomplete';
import SingleImageUpload from 'components/SingleImageUpload/SingleImageUpload';
import styles from './Step1.module.scss';

class Step1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alert: '',
            notifDialog: { open: false, message: '' },
            disabled: !props.company.id,
            id: props.company.id || 0,
            name: props.company.name || '',
            nameState: props.company.name ? 'success' : '',
            kennitala: props.company.kennitala || '',
            kennitalaState: props.company.kennitala ? 'success' : '',
            phone: this.renderContact(
                props.company.torgid_company_contacts,
                props.company.phone,
                'phone'
            ),
            phoneValue: '',
            phoneState: '',
            phoneAdding: false,
            email: this.renderContact(
                props.company.torgid_company_contacts,
                props.company.email,
                'email'
            ),
            emailValue: '',
            emailState: '',
            emailAdding: false,
            website: this.renderContact(
                props.company.torgid_company_contacts,
                props.company.website,
                'website'
            ),
            websiteValue: '',
            websiteState: '',
            websiteAdding: false,
            torgid_company_tags: [],
            // torgid_company_awards: [],
            tagsService: props.company.torgid_company_tags
                ? props.company.torgid_company_tags
                      .filter((val) => val.type === 'service')
                      .map((t) => t.value)
                : [],
            tagsServiceValue: '',
            tagsServiceState: '',
            tagsBrand: props.company.torgid_company_tags
                ? props.company.torgid_company_tags
                      .filter((val) => val.type === 'brand')
                      .map((t) => t.value)
                : [],
            tagsBrandValue: '',
            tagsBrandState: '',
            // awards: props.company.torgid_company_awards ? props.company.torgid_company_awards.map(val => `${val.type}:${val.value}`) : [],
            // awardsValue: "",
            // awardsState: "",
            description: props.company.description || '',
            description_en: props.company.description_en || '',
            offer_limit: props.company.offer_limit || 5,
            type: props.company.type ? props.company.type : 'regular',
            logo: '',
            logoPreview: props.company.logo || '',
            facebook: props.company.torgid_company_social
                ? props.company.torgid_company_social.facebook
                : null,
            facebookState: props.company.torgid_company_social
                ? !!props.company.torgid_company_social.facebook
                : false,
            twitter: props.company.torgid_company_social
                ? props.company.torgid_company_social.twitter
                : null,
            twitterState: props.company.torgid_company_social
                ? !!props.company.torgid_company_social.twitter
                : false,
            instagram: props.company.torgid_company_social
                ? props.company.torgid_company_social.instagram
                : null,
            instagramState: props.company.torgid_company_social
                ? !!props.company.torgid_company_social.instagram
                : false,
            youtube: props.company.torgid_company_social
                ? props.company.torgid_company_social.youtube
                : null,
            youtubeState: props.company.torgid_company_social
                ? !!props.company.torgid_company_social.youtube
                : false,
            pinterest: props.company.torgid_company_social
                ? props.company.torgid_company_social.pinterest
                : null,
            pinterestState: props.company.torgid_company_social
                ? !!props.company.torgid_company_social.pinterest
                : false,
            linkedin: props.company.torgid_company_social
                ? props.company.torgid_company_social.linkedin
                : null,
            linkedinState: props.company.torgid_company_social
                ? !!props.company.torgid_company_social.linkedin
                : false,
            torgid_company_category_id: props.company.torgid_company_category_id || null,
            torgid_company_categories: props.company.torgid_company_category_nxns
                ? props.company.torgid_company_category_nxns.map(
                      (data) => data.torgid_company_category_id
                  )
                : [],
            imgUpload: this.imgUpload.bind(this),
            editingContact: null,
            editingContactValue: '',
        };
        this.contactInputRef = React.createRef();
    }

    static getDerivedStateFromProps(props, state) {
        if (!props.company) return null;
        if (props.company.company_from === 'Torgid') {
            if (props.company.id && props.company.id !== state.id) {
                return {
                    id: props.company.id || 0,
                    name: props.company.name || '',
                    nameState: props.company.name ? 'success' : '',
                    kennitala: props.company.kennitala || '',
                    kennitalaState: props.company.kennitala ? 'success' : '',
                    phone: props.company.torgid_company_contacts
                        ? props.company.torgid_company_contacts
                              .filter((val) => val.type === 'phone')
                              .map((t) => t.value)
                        : [],
                    email: props.company.torgid_company_contacts
                        ? props.company.torgid_company_contacts
                              .filter((val) => val.type === 'email')
                              .map((t) => t.value)
                        : [],
                    website: props.company.torgid_company_contacts
                        ? props.company.torgid_company_contacts
                              .filter((val) => val.type === 'website')
                              .map((t) => t.value)
                        : [],
                    tagsService: props.company.torgid_company_tags
                        ? props.company.torgid_company_tags
                              .filter((val) => val.type === 'service')
                              .map((t) => t.value)
                        : [],
                    tagsBrand: props.company.torgid_company_tags
                        ? props.company.torgid_company_tags
                              .filter((val) => val.type === 'brand')
                              .map((t) => t.value)
                        : [],
                    // awards: props.company.torgid_company_awards ? props.company.torgid_company_awards.map(val => `${val.type}:${val.value}`) : [],
                    description: props.company.description || '',
                    description_en: props.company.description_en || '',
                    offer_limit: props.company.offer_limit || 5,
                    type: props.company.type ? props.company.type : 'regular',
                    logo: '',
                    logoPreview: props.company.logo || '',
                    facebook: props.company.torgid_company_social
                        ? props.company.torgid_company_social.facebook
                        : null,
                    facebookState: props.company.torgid_company_social
                        ? !!props.company.torgid_company_social.facebook
                        : false,
                    twitter: props.company.torgid_company_social
                        ? props.company.torgid_company_social.twitter
                        : null,
                    twitterState: props.company.torgid_company_social
                        ? !!props.company.torgid_company_social.twitter
                        : false,
                    instagram: props.company.torgid_company_social
                        ? props.company.torgid_company_social.instagram
                        : null,
                    instagramState: props.company.torgid_company_social
                        ? !!props.company.torgid_company_social.instagram
                        : false,
                    youtube: props.company.torgid_company_social
                        ? props.company.torgid_company_social.youtube
                        : null,
                    youtubeState: props.company.torgid_company_social
                        ? !!props.company.torgid_company_social.youtube
                        : false,
                    pinterest: props.company.torgid_company_social
                        ? props.company.torgid_company_social.pinterest
                        : null,
                    pinterestState: props.company.torgid_company_social
                        ? !!props.company.torgid_company_social.pinterest
                        : false,
                    linkedin: props.company.torgid_company_social
                        ? props.company.torgid_company_social.linkedin
                        : null,
                    linkedinState: props.company.torgid_company_social
                        ? !!props.company.torgid_company_social.linkedin
                        : false,
                    torgid_company_category_id: props.company.torgid_company_category_id || null,
                };
            }
        } else if (props.company.company_from === '1819') {
            if (props.company.name !== state.name) {
                return {
                    id: 0,
                    name: props.company.name || '',
                    nameState: props.company.name ? 'success' : '',
                    phone: props.company.phones || [],
                    email: props.company.email || [],
                    website: props.company.website || [],
                    logo:
                        props.company.logo && props.company.logo.length > 0
                            ? state.imgUpload(props.company.logo, 'logo')
                            : '',
                    logoPreview: props.company.logo || '',
                    facebook: props.company.facebook || null,
                    facebookState: !!props.company.facebook,
                    twitter: props.company.twitter || null,
                    twitterState: !!props.company.twitter,
                    instagram: props.company.instagram || null,
                    instagramState: !!props.company.instagram,
                    tagsService: props.company.services ? props.company.services.split(' ') : [],
                    tagsBrand: props.company.brands ? props.company.brands.split(' ') : [],
                };
            }
        }
        return null;
    }

    imgUpload = async (url, state) => {
        var thisS = this;
        const res = await fetch(url);
        const imageBlob = await res.blob();

        var reader = new FileReader();
        reader.readAsDataURL(imageBlob);
        reader.onload = function (e) {
            e.target.result.length > 0 && thisS.setState({ [state]: e.target.result });
        };
    };

    // imgUpload = (url, state) => {
    //   var request = new XMLHttpRequest();
    //   var thisS = this;
    //   request.open('GET', url, true);
    //   request.responseType = 'blob';
    //   request.onload = function() {
    //     var reader = new FileReader();
    //     reader.readAsDataURL(request.response);
    //     reader.onload = function(e){
    //       e.target.result.length>0 && thisS.setState({[state]: e.target.result});
    //     };
    //   };
    //   request.send();
    // };

    renderContact = (data, data2, type) => {
        let temp = [];
        if (data && data.length > 0) {
            data.map((value, index) => {
                if (value.type === type) {
                    temp.push(value.value);
                }
            });
        } else if (data && data.length === 0 && data2) {
            temp.push(data2);
        }

        return temp;
    };

    handleKeyDown = (evt, type) => {
        if (['Enter', 'Tab', ','].includes(evt.key)) {
            evt.preventDefault();
            var value = this.state[type + 'Value'].trim();
            if (value && this.isValid(value, type)) {
                this.setState({
                    [type]: [...this.state[type], this.state[type + 'Value']],
                    [type + 'Value']: '',
                });
            }
        }
    };

    handleChangeContact = (evt, type) => {
        this.setState({
            [type + 'Value']: evt.target.value,
            [type + 'State']: null,
        });
    };

    handleDelete = (item, type) => {
        this.setState({
            [type]: this.state[type].filter((i) => i !== item),
        });
    };

    isValid(value, type) {
        let error = null;

        if (this.state[type].includes(value)) {
            error = `this has already been added.`;
        }

        if (type === 'email') {
            if (!this.verifyEmail(value)) {
                error = `this not a valid email.`;
            }
        } else if (type === 'phone') {
            if (!/^\d{7}$/.test(value)) {
                error = `this not a valid phone.`;
            }
        } else if (type === 'website') {
            if (
                !/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi.test(
                    value
                )
            ) {
                error = `this not a valid website.`;
            }
        } else if (type === 'awards') {
            if (!/^\w{3,}:\w{3,}$/.test(value)) {
                error = `this not a valid award.`;
            }
        }

        if (error) {
            this.setState({ [type + 'State']: error });
            return false;
        }

        return true;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState !== this.state && this.props.onFieldChange) {
            this.props.onFieldChange();
        }
    }

    sendState() {
        return this.state;
    }

    verifyLength(value, length) {
        return value.length >= length;
    }

    verifyEmail(value) {
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailRex.test(value);
    }

    handleChange = (data, type) => {
        this.setState({ [type]: data });
    };

    onUpload(data, type) {
        this.setState({ [type]: data });
    }

    hideAlert = () => {
        this.setState({ alert: null });
    };

    handleChangeCategory = (data) => {
        if (data) {
            let ids = data.map((data) => data.id);
            this.setState({ torgid_company_categories: ids });
        }
    };

    handleCheckKennitala = () => {
        this.props.checkCompany(this.state.kennitala);
        this.setState({ disabled: false });
    };

    autoTranslate = (type, fromLn, toLn) => {
        let textOld = this.state.description;
        let text = textOld.replace(/&/g, '');
        axios
            .get(
                `https://translation.googleapis.com/language/translate/v2?key=AIzaSyA5AF_VTEbn4TXQ2uMWsaEx0Al53mT7aOU&q=${text}&source=${fromLn}&target=${toLn}`
            )
            .then((response) => {
                if (response.status === 200) {
                    let translatedText = response.data.data.translations[0].translatedText;
                    this.setState({
                        [type]: translatedText.replace(new RegExp('&#39;', 'g'), "'"),
                    });
                } else {
                    this.setState({ notifDialog: { open: true, message: response.statusText } });
                    setTimeout(
                        () => this.setState({ notifDialog: { open: false, message: '' } }),
                        2000
                    );
                }
            });
    };

    change(event, stateName, type, stateNameEqualTo) {
        if (type === 'length') {
            if (this.verifyLength(event.target.value, stateNameEqualTo)) {
                this.setState({ [stateName + 'State']: 'success' });
            } else {
                this.setState({ [stateName + 'State']: 'error' });
            }
        }
        if (type === 'lengthEqual') {
            if (event.target.value.length === stateNameEqualTo) {
                this.setState({ [stateName + 'State']: 'success' });
            } else {
                this.setState({ [stateName + 'State']: 'error' });
            }
        }
        if (type === 'email') {
            if (this.verifyEmail(event.target.value, stateNameEqualTo)) {
                this.setState({ [stateName + 'State']: 'success' });
            } else {
                this.setState({ [stateName + 'State']: 'error' });
            }
        }
        if (type === 'phone') {
            if (/^\d{7}$/.test(event.target.value)) {
                this.setState({ [stateName + 'State']: 'success' });
            } else {
                this.setState({ [stateName + 'State']: 'error' });
            }
        }
        this.setState({ [stateName]: event.target.value });
    }

    isValidated() {
        if (
            this.state.nameState === 'success' &&
            this.state.kennitalaState === 'success'
            // this.state.phone.length > 0 &&
            // this.state.email.length > 0 &&
            // this.state.website.length > 0
        ) {
            return true;
        } else {
            if (this.state.nameState !== 'success') {
                this.setState({ nameState: 'error' });
            }
            if (this.state.kennitalaState !== 'success') {
                this.setState({ kennitalaState: 'error' });
            }
            // if (this.state.phone.length <= 0) {
            //   this.setState({ phoneState: "Vinsamlega fylltu reitinn út" });
            // }
            // if (this.state.email.length <= 0) {
            //   this.setState({ emailState: "Vinsamlega fylltu reitinn út" });
            // }
            // if (this.state.website.length <= 0) {
            //   this.setState({ websiteState: "Vinsamlega fylltu reitinn út" });
            // }
        }
        return false;
    }

    handleAdd = (type) => {
        var value = this.state[type + 'Value'].trim();
        if (value && this.isValid(value, type)) {
            this.setState({
                [type]: [...this.state[type], value],
                [type + 'Value']: '',
                [type + 'Adding']: false,
                [type + 'State']: null,
            });
        }
    };

    startAdding = (type) => {
        this.setState(
            {
                [type + 'Adding']: true,
                [type + 'Value']: '',
                [type + 'State']: null,
                editingContact: null,
            },
            () => {
                if (this.contactInputRef.current) this.contactInputRef.current.focus();
            }
        );
    };

    cancelAdding = (type) => {
        this.setState({ [type + 'Adding']: false, [type + 'Value']: '', [type + 'State']: null });
    };

    startEditing = (type, index) => {
        this.setState(
            {
                editingContact: { type, index },
                editingContactValue: this.state[type][index],
                [type + 'Adding']: false,
                [type + 'State']: null,
            },
            () => {
                if (this.contactInputRef.current) this.contactInputRef.current.focus();
            }
        );
    };

    cancelEditing = () => {
        this.setState({ editingContact: null, editingContactValue: '' });
    };

    commitEditing = (type) => {
        const { editingContact, editingContactValue } = this.state;
        if (!editingContact) return;
        const value = editingContactValue.trim();
        if (!value) {
            const updated = [...this.state[type]];
            updated.splice(editingContact.index, 1);
            this.setState({ [type]: updated, editingContact: null, editingContactValue: '' });
            return;
        }
        const original = this.state[type][editingContact.index];
        if (value === original) {
            this.setState({ editingContact: null, editingContactValue: '' });
            return;
        }
        if (this.isValid(value, type)) {
            const updated = [...this.state[type]];
            updated[editingContact.index] = value;
            this.setState({
                [type]: updated,
                editingContact: null,
                editingContactValue: '',
                [type + 'State']: null,
            });
        }
    };

    handleEditKeyDown = (evt, type) => {
        if (evt.key === 'Escape') {
            evt.preventDefault();
            this.cancelEditing();
            return;
        }
        if (['Enter', 'Tab'].includes(evt.key)) {
            evt.preventDefault();
            this.commitEditing(type);
        }
    };

    handleContactKeyDown = (evt, type) => {
        if (evt.key === 'Escape') {
            evt.preventDefault();
            this.cancelAdding(type);
            return;
        }
        if (['Enter', 'Tab'].includes(evt.key)) {
            evt.preventDefault();
            var value = this.state[type + 'Value'].trim();
            if (value && this.isValid(value, type)) {
                this.setState({
                    [type]: [...this.state[type], value],
                    [type + 'Value']: '',
                    [type + 'Adding']: false,
                    [type + 'State']: null,
                });
            }
        }
    };

    handleContactBlur = (type) => {
        var value = this.state[type + 'Value'].trim();
        if (!value) {
            this.cancelAdding(type);
            return;
        }
        if (this.isValid(value, type)) {
            this.setState({
                [type]: [...this.state[type], value],
                [type + 'Value']: '',
                [type + 'Adding']: false,
                [type + 'State']: null,
            });
        }
    };

    renderContactSection(items, type, inputValue, inputState, config) {
        const { t } = this.props;
        const isAdding = this.state[type + 'Adding'];
        const { editingContact, editingContactValue } = this.state;
        return (
            <div>
                <div className={styles.contactHeader}>
                    <p className={styles.contactHeaderTitle}>{t(config.titleKey)}</p>
                    <button
                        type="button"
                        className={styles.contactAddBtn}
                        onClick={() => this.startAdding(type)}
                    >
                        {t(config.addKey)}
                    </button>
                </div>
                <div className={styles.contactCard}>
                    {items.length === 0 && !isAdding ? (
                        <div className={styles.contactEmpty} onClick={() => this.startAdding(type)}>
                            <p className={styles.contactEmptyTitle}>{t(config.emptyKey)}</p>
                            <p className={styles.contactEmptySub}>{t(config.emptySubKey)}</p>
                        </div>
                    ) : (
                        <>
                            {items.map((item, idx) => {
                                const isEditing =
                                    editingContact &&
                                    editingContact.type === type &&
                                    editingContact.index === idx;
                                return (
                                    <div className={styles.contactItemRow} key={`${type}-${idx}`}>
                                        {isEditing ? (
                                            <input
                                                ref={this.contactInputRef}
                                                className={styles.contactItemInput}
                                                type="text"
                                                value={editingContactValue}
                                                onChange={(e) =>
                                                    this.setState({
                                                        editingContactValue: e.target.value,
                                                    })
                                                }
                                                onKeyDown={(e) => this.handleEditKeyDown(e, type)}
                                                onBlur={() => this.commitEditing(type)}
                                            />
                                        ) : (
                                            <span
                                                className={styles.contactItemValue}
                                                onClick={() => this.startEditing(type, idx)}
                                            >
                                                {item}
                                            </span>
                                        )}
                                        <button
                                            type="button"
                                            className={styles.contactRemoveBtn}
                                            onMouseDown={(e) => e.preventDefault()}
                                            onClick={() => this.handleDelete(item, type)}
                                        >
                                            <RemoveCircleOutline style={{ fontSize: '1.1rem' }} />
                                        </button>
                                    </div>
                                );
                            })}
                            {isAdding && (
                                <>
                                    <div className={styles.contactInputRow}>
                                        <input
                                            ref={this.contactInputRef}
                                            className={styles.contactInput}
                                            type="text"
                                            placeholder={t(config.placeholderKey)}
                                            value={inputValue}
                                            onChange={(event) =>
                                                this.handleChangeContact(event, type)
                                            }
                                            onKeyDown={(event) =>
                                                this.handleContactKeyDown(event, type)
                                            }
                                            onBlur={() => this.handleContactBlur(type)}
                                        />
                                    </div>
                                    {inputState &&
                                        typeof inputState === 'string' &&
                                        inputState !== 'success' && (
                                            <div className={styles.contactInputError}>
                                                {inputState}
                                            </div>
                                        )}
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        );
    }

    renderTagSection(items, type, inputValue, inputState, placeholderKey) {
        const { t } = this.props;
        const hasValue = inputValue && inputValue.trim().length > 0;
        return (
            <>
                {items.length > 0 && (
                    <div className={styles.tagList}>
                        {items.map((item) => (
                            <div className={styles.tagChip} key={item}>
                                {item}
                                <button
                                    type="button"
                                    className={styles.tagChipRemove}
                                    onClick={() => this.handleDelete(item, type)}
                                >
                                    &times;
                                </button>
                            </div>
                        ))}
                    </div>
                )}
                <div className={styles.tagInputRow}>
                    <CustomInput
                        success={inputState === 'success'}
                        error={!!inputState}
                        labelText={inputState || t(placeholderKey)}
                        id={type}
                        formControlProps={{ fullWidth: true }}
                        inputProps={{
                            value: inputValue,
                            onChange: (event) => this.handleChangeContact(event, type),
                            onKeyDown: (event) => this.handleKeyDown(event, type),
                        }}
                    />
                    <button
                        type="button"
                        className={`${styles.tagAddBtn} ${hasValue ? styles.tagAddBtnActive : ''}`}
                        onClick={() => this.handleAdd(type)}
                        tabIndex={-1}
                    >
                        +
                    </button>
                </div>
            </>
        );
    }

    renderSocialInput(name, Icon, stateKey, urlDefault) {
        if (!this.state[stateKey + 'State']) return null;
        return (
            <div className={styles.socialInputRow}>
                <FormControl fullWidth>
                    <Input
                        id={`input-${name}`}
                        startAdornment={
                            <InputAdornment position="start">
                                <Icon />
                            </InputAdornment>
                        }
                        value={this.state[stateKey] || urlDefault}
                        onChange={(event) => this.handleChange(event.target.value, stateKey)}
                        style={{ fontSize: '0.9rem' }}
                    />
                </FormControl>
                <Close
                    onClick={() => this.handleChange(false, stateKey + 'State')}
                    className={styles.socialCloseBtn}
                />
            </div>
        );
    }

    render() {
        const { classes, company, t, data2, isSuperAdmin } = this.props;
        const options =
            data2 &&
            data2.map((option) => {
                const firstLetter = (option.title || '').charAt(0).toUpperCase();
                return {
                    firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
                    ...option,
                };
            });

        return (
            <div className={styles.container}>
                {this.state.alert}
                <ConfirmDialog
                    open={this.state.notifDialog.open}
                    type="warning"
                    title={this.state.notifDialog.message}
                    onConfirm={() => this.setState({ notifDialog: { open: false, message: '' } })}
                />

                {/* 1. Myndir og auðkenni */}
                <div>
                    <h4 className={styles.sectionTitle}>{t('company.about')}</h4>
                    <div className={styles.sectionCard}>
                        <div className={styles.identityGrid}>
                            <SingleImageUpload
                                image={this.state.logo || this.state.logoPreview}
                                aspectRatio={1}
                                cropShape="round"
                                style={{ width: 110, height: 110 }}
                                onUpload={(data) =>
                                    this.setState({ logo: data, logoPreview: data })
                                }
                                onDelete={() => this.setState({ logo: '', logoPreview: '' })}
                            />
                            <div className={styles.identityFields}>
                                <div
                                    className={`${styles.fieldGroup} ${
                                        this.state.nameState === 'error'
                                            ? styles.fieldGroupError
                                            : ''
                                    }`}
                                >
                                    <label className={styles.fieldLabel} htmlFor="company-name">
                                        {t('name')}{' '}
                                        <span className={styles.fieldRequired}>
                                            {t('required')}
                                        </span>
                                    </label>
                                    <input
                                        id="company-name"
                                        className={styles.fieldInput}
                                        type="text"
                                        value={this.state.name}
                                        onChange={(event) =>
                                            this.change(event, 'name', 'length', 2)
                                        }
                                    />
                                </div>
                                <div
                                    className={`${styles.fieldGroup} ${
                                        this.state.kennitalaState === 'error'
                                            ? styles.fieldGroupError
                                            : ''
                                    }`}
                                >
                                    <label className={styles.fieldLabel} htmlFor="kennitala">
                                        {t('kennitala')}{' '}
                                        <span className={styles.fieldRequired}>
                                            {t('required')}
                                        </span>
                                    </label>
                                    <input
                                        id="kennitala"
                                        className={styles.fieldInput}
                                        type="number"
                                        value={this.state.kennitala}
                                        onChange={(event) =>
                                            this.change(event, 'kennitala', 'lengthEqual', 10)
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 2–4. Tengiliðaupplýsingar: Netfang, Símanúmer, Vefsíða */}
                <div className={styles.contactGrid}>
                    {this.renderContactSection(
                        this.state.email,
                        'email',
                        this.state.emailValue,
                        this.state.emailState,
                        {
                            titleKey: 'email',
                            addKey: 'company.add_email',
                            emptyKey: 'company.no_email',
                            emptySubKey: 'company.click_to_add_email',
                            placeholderKey: 'company.type_email',
                        }
                    )}
                    {this.renderContactSection(
                        this.state.phone,
                        'phone',
                        this.state.phoneValue,
                        this.state.phoneState,
                        {
                            titleKey: 'phone',
                            addKey: 'company.add_phone',
                            emptyKey: 'company.no_phone',
                            emptySubKey: 'company.click_to_add_phone',
                            placeholderKey: 'company.type_phone',
                        }
                    )}
                    {this.renderContactSection(
                        this.state.website,
                        'website',
                        this.state.websiteValue,
                        this.state.websiteState,
                        {
                            titleKey: 'website',
                            addKey: 'company.add_website',
                            emptyKey: 'company.no_website',
                            emptySubKey: 'company.click_to_add_website',
                            placeholderKey: 'company.type_website',
                        }
                    )}
                </div>

                {/* 5. Lýsing */}
                <div>
                    <h4 className={styles.sectionTitle}>{t('description')}</h4>
                    <div className={styles.sectionCard}>
                        <div className={styles.langGrid}>
                            <div className={styles.langCol}>
                                <p className={styles.langColHeader}>IS</p>
                                <TextareaAutosize
                                    className={classes.txtArea}
                                    minRows={4}
                                    maxRows={8}
                                    id="description"
                                    aria-label="description"
                                    placeholder={t('description')}
                                    value={this.state.description}
                                    onChange={(event) =>
                                        this.change(event, 'description', 'length', 10)
                                    }
                                />
                            </div>
                            <div className={styles.langDivider}>
                                {this.state.description ? (
                                    <button
                                        className={styles.translateBtn}
                                        onClick={() =>
                                            this.autoTranslate('description_en', 'is', 'en')
                                        }
                                    >
                                        →
                                    </button>
                                ) : null}
                            </div>
                            <div className={styles.langCol}>
                                <p className={styles.langColHeader}>EN</p>
                                <TextareaAutosize
                                    className={classes.txtArea}
                                    minRows={4}
                                    maxRows={8}
                                    id="description_en"
                                    aria-label="description_en"
                                    placeholder={t('description_en')}
                                    value={this.state.description_en}
                                    onChange={(event) => this.change(event, 'description_en')}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* 6. Leitarorð — óvirkt, tags eru eingöngu til sýningar í appinu */}
                {/*<div>
                    <h4 className={styles.sectionTitle}>{t('company.tags')}</h4>
                    <div className={styles.sectionCard}>
                        <div style={{ marginBottom: 16 }}>
                            <p className={styles.langColHeader}>{t('company.type_service')}</p>
                            {this.renderTagSection(
                                this.state.tagsService, 'tagsService',
                                this.state.tagsServiceValue, this.state.tagsServiceState,
                                'company.type_service'
                            )}
                        </div>
                        <div>
                            <p className={styles.langColHeader}>{t('company.type_brand')}</p>
                            {this.renderTagSection(
                                this.state.tagsBrand, 'tagsBrand',
                                this.state.tagsBrandValue, this.state.tagsBrandState,
                                'company.type_brand'
                            )}
                        </div>
                    </div>
                </div>*/}

                {/* 7. Flokkar og stillingar — aðeins fyrir super admins */}
                {isSuperAdmin && (
                    <div>
                        <h4 className={styles.sectionTitle}>{t('company.info')}</h4>
                        <div className={styles.sectionCard}>
                            <div className={styles.settingsGrid}>
                                <CustomInput
                                    labelText={<span>{t('offer_limit')}</span>}
                                    id="offer_limit"
                                    formControlProps={{ fullWidth: true }}
                                    inputProps={{
                                        value: this.state.offer_limit,
                                        type: 'number',
                                        onChange: (event) => this.change(event, 'offer_limit'),
                                    }}
                                />
                                <FormControl
                                    fullWidth
                                    className={classes.selectFormControl}
                                    style={{ marginTop: '10px' }}
                                    variant="standard"
                                >
                                    <InputLabel
                                        htmlFor="simple-select"
                                        className={classes.selectLabel}
                                    >
                                        {t('type')}
                                    </InputLabel>
                                    <Select
                                        MenuProps={{ className: classes.selectMenu }}
                                        classes={{ select: classes.select }}
                                        value={this.state.type}
                                        onChange={(e) => this.handleChange(e.target.value, 'type')}
                                        inputProps={{ name: 'type', id: 'type' }}
                                    >
                                        <MenuItem
                                            classes={{ selected: classes.dSelected }}
                                            value="regular"
                                        >
                                            {t('company.regular')}
                                        </MenuItem>
                                        <MenuItem
                                            classes={{ selected: classes.dSelected }}
                                            value="premium"
                                        >
                                            {t('company.premium')}
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                <Autocomplete
                                    multiple
                                    id="companies"
                                    onChange={(event, newValue) =>
                                        this.handleChangeCategory(newValue)
                                    }
                                    value={
                                        this.state.torgid_company_categories && options
                                            ? this.state.torgid_company_categories.map((data) =>
                                                  options.find((item) => item.id === data)
                                              )
                                            : []
                                    }
                                    getOptionLabel={(option) => option?.title}
                                    getOptionSelected={(option, value) => option.id === value.id}
                                    options={
                                        options
                                            ? options.sort(
                                                  (a, b) =>
                                                      -b.firstLetter.localeCompare(a.firstLetter)
                                              )
                                            : []
                                    }
                                    groupBy={(option) => option.firstLetter}
                                    style={{ marginTop: 10 }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            label={t('choose_category')}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/* 8. Samfélagsmiðlar */}
                <div>
                    <h4 className={styles.sectionTitle}>{t('social_links')}</h4>
                    <div className={styles.sectionCard}>
                        <div className={styles.socialIconRow}>
                            <Facebook
                                className={`${styles.socialIcon} ${
                                    this.state.facebookState ? styles.socialIconActive : ''
                                }`}
                                onClick={() => this.handleChange(true, 'facebookState')}
                            />
                            <Twitter
                                className={`${styles.socialIcon} ${
                                    this.state.twitterState ? styles.socialIconActive : ''
                                }`}
                                onClick={() => this.handleChange(true, 'twitterState')}
                            />
                            <Instagram
                                className={`${styles.socialIcon} ${
                                    this.state.instagramState ? styles.socialIconActive : ''
                                }`}
                                onClick={() => this.handleChange(true, 'instagramState')}
                            />
                            <YouTube
                                className={`${styles.socialIcon} ${
                                    this.state.youtubeState ? styles.socialIconActive : ''
                                }`}
                                onClick={() => this.handleChange(true, 'youtubeState')}
                            />
                            <Pinterest
                                className={`${styles.socialIcon} ${
                                    this.state.pinterestState ? styles.socialIconActive : ''
                                }`}
                                onClick={() => this.handleChange(true, 'pinterestState')}
                            />
                            <LinkedIn
                                className={`${styles.socialIcon} ${
                                    this.state.linkedinState ? styles.socialIconActive : ''
                                }`}
                                onClick={() => this.handleChange(true, 'linkedinState')}
                            />
                        </div>
                        {this.renderSocialInput(
                            'facebook',
                            Facebook,
                            'facebook',
                            'https://facebook.com/'
                        )}
                        {this.renderSocialInput(
                            'twitter',
                            Twitter,
                            'twitter',
                            'https://twitter.com/'
                        )}
                        {this.renderSocialInput(
                            'instagram',
                            Instagram,
                            'instagram',
                            'https://instagram.com/'
                        )}
                        {this.renderSocialInput(
                            'youtube',
                            YouTube,
                            'youtube',
                            'https://youtube.com/'
                        )}
                        {this.renderSocialInput(
                            'pinterest',
                            Pinterest,
                            'pinterest',
                            'https://pinterest.com/'
                        )}
                        {this.renderSocialInput(
                            'linkedin',
                            LinkedIn,
                            'linkedin',
                            'https://linkedin.com/'
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('', { withRef: true })(Step1);
